import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import TaskModalStandard from 'bundles/apex/tasks/task_modal/standard';

export default function AddTask({
  className,
  createTask,
  displayAs,
  formDependenciesPath,
}) {
  const [showModal, setShowModal] = useState();
  const AddComponent = displayAs || AddControl;

  return <React.Fragment>
    <AddComponent aria-label="Add task" className={className} onClick={() => setShowModal(true)}>
      Add task
    </AddComponent>

    <TaskModalStandard
      createTask={createTask}
      formDependenciesPath={formDependenciesPath}
      show={showModal}
      onHide={() => setShowModal(false)}
    />
  </React.Fragment>;
}

AddTask.propTypes = {
  className: PropTypes.string,
  createTask: PropTypes.func,
  displayAs: PropTypes.elementType,
  formDependenciesPath: PropTypes.string,
};
